module.exports = __webpack_public_path__ + "static/media/GrayC.645fe2b6.png";